import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import NavBar from '../components/NavBar';
import BillplzLogo from '../img/billplz.png';
import { FaSpinner } from 'react-icons/fa';
import { Helmet } from 'react-helmet';
import BackButtonWhite from '../components/BackButtonWhite';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import translations from '../translations';

const Checkout = () => {
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'en');
  const t = translations[language];
  const { id } = useParams();
  const { pakej } = useParams();
  const navigate = useNavigate();
  const [promoCode, setPromoCode] = useState('');
  const [name, setName] = useState('');  // Add name state
  const [email, setEmail] = useState('');  // Add name state
  // const email = localStorage.getItem('email');
  const [mobile, setMobile] = useState('');  // Add email state
  const [price, setPrice] = useState(50);
  const [subtotal, setSubtotal] = useState(50);
  const [discount, setDiscount] = useState(0);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [loadingPay, setLoadingPay] = useState(false);
  const [errors, setErrors] = useState({
    name: '',
    mobile: '',
  });
  
  const [productId, setProductId] = useState(false);

  useEffect(() => {
    const fetchFeatures = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/features/${pakej}`);
        const data = response.data;

        setSubtotal(data.sale_price);
        setPrice(data.sale_price);
        setProductId(data.product_id);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchFeatures();
  }, [id]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/kad/${id}`);
        const data = response.data;

        setName(data.name);
        setEmail(data.email);
        setMobile(data.mobile);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, [id]);

  // useEffect(() => {
  //   const fetchPrice = async () => {
  //     try {
  //       const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/settings`);
  //       const data = response.data;

  //       setSubtotal(data.price);
  //       setPrice(data.price);
  //     } catch (error) {
  //       console.error('Error fetching data:', error);
  //     }
  //   };

  //   fetchPrice();
  // }, [id]);

  const applyPromoCode = () => {
    setLoading(true);
      const sanitizedPromoCode = promoCode.replace(/\s/g, '').toLowerCase();

      axios.get(`${process.env.REACT_APP_API_BASE_URL}/promocode/${sanitizedPromoCode}`)
        .then(response => {
          const matchedPromoCode = response.data;
          if (matchedPromoCode.expirationDate) {
            const currentDate = new Date();
            if (currentDate <= new Date(matchedPromoCode.expirationDate)) {
              if(matchedPromoCode.claimed < matchedPromoCode.valid) {
                const discountFloat = parseFloat(matchedPromoCode.discount);
                setDiscount(discountFloat);
                setLoading(false);
                setSuccessMessage('Promo code applied successfully!');
                setErrorMessage('');
              } else {
                setDiscount(0);
                setLoading(false);
                setSuccessMessage('');
                setErrorMessage(t.promoCodeFullyClaimed);
              }
            } else {
              setDiscount(0);
              setLoading(false);
              setSuccessMessage('');
              setErrorMessage(t.promoCodeExpired);
            }
          } else {
            const discountInt = parseInt(matchedPromoCode.discount);
            setDiscount(discountInt);
            setLoading(false);
            setSuccessMessage(t.promoCodeAppliedSuccessfully);
            setErrorMessage('');
          }
        })
        .catch(error => {
            console.error('Error fetching data:', error);
            setDiscount(0);
            setSuccessMessage('');
            setLoading(false);
            setErrorMessage(t.invalidPromoCode);
        });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    // Use the appropriate state-setting function based on the input field's name
    if (name === 'fullName') {
      setName(value);
    } else if (name === 'mobile') {
      setMobile(value);
    } else if (name === 'promoCode') {
      setPromoCode(value);
    }
    // Add more conditions for other fields if needed
  };

  const pay = async (promo, total) => {
    localStorage.setItem('cardId', id);
    setLoadingPay(true);
    try {
      if (total === 0) {
        // Post client_id and promo_code using axios
        const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/free-promo`, {
          client_id: id,       // assuming `id` is the client ID
          promo_code: promo    // promo code passed in as a parameter
        });
        console.log('Promo applied successfully:', response.data);
        navigate(`/dashboard/${id}`);
      } else {
        // Redirect to the pay URL if total is not 0
        // const payURL = `https://kadkahwinrsvp.com/billplzpost.php?clientId=${id}&name=${name}&email=${email}&mobile=${mobile}&amount=${amount}&promo_code=${promo}&reference_1_label=&reference_2_label=`;
        // window.location.href = payURL;

        const response = await axios.post(`${process.env.REACT_APP_PAY_BASE_URL}/wp-json/wc/v3/orders`, {
          billing: {
            first_name: name,
            email: email,
            phone: mobile
          },
          meta_data: [
            {
              key: "card_id",  // Store card ID as custom metadata
              value: id,
            },
            {
              key: "promo_code",
              value: promo,
            },
            {
              key: "pakej",
              value: pakej,
            }
          ],
          line_items: [
            {
              product_id: productId,  // The product ID you're using
              quantity: 1,
              price: total,  // Dynamically set price (use your price variable here)
              total: (total * 1).toFixed(2),  // Ensure total is set
            }
          ]
        }, {
          auth: {
            username: process.env.REACT_APP_PAY_AUTH_USERNAME,
            password: process.env.REACT_APP_PAY_AUTH_PASS
          }
        });
      
        const orderId = response.data.id;
        const orderKey = response.data.order_key;
        window.location.href = `${process.env.REACT_APP_PAY_BASE_URL}/checkout/order-pay/${orderId}/?pay_for_order=true&key=${orderKey}`;
      }
    } catch (error) {
      // console.error('Error applying promo:', error);
      console.error('Error creating order:', error);
      alert(t.failedToCreateOrder);
    }
  };
  

  // const pay = (promo, amount) => {
  //   const payURL = `https://kadkahwinrsvp.com/billplzpost.php?clientId=${id}&name=${name}&email=${email}&mobile=${mobile}&amount=${amount}&promo_code=${promo}&reference_1_label=&reference_2_label=`;
  //   window.location.href = payURL;
  // }

  const handleSubmit = () => {
    setLoadingPay(true);
    // Validate the form
    let formIsValid = true;

    if (!name) {
      setErrors((prevErrors) => ({ ...prevErrors, name: t.pleaseEnterYourName }));
      formIsValid = false;
    }

    if (!mobile) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        mobile: t.pleaseEnterYourPhoneNumber,
      }));
      formIsValid = false;
    }

    if (!email) {
      setErrors((prevErrors) => ({ ...prevErrors, email: t.enterYourEmail }));
      formIsValid = false;
    }

    // Check if all required fields are provided
    if (formIsValid) {
      const total = subtotal - discount;
      const amount = Math.round(total * 100);
      
      if (promoCode.trim() === '') {
        pay('none', total);
      } else {
        pay(promoCode, total);
      }
      
      // if (promoCode.trim() === '') {
      //   const publishURL = `/publish/${name}/${email}/${mobile}/${total}/none`;
      //   window.location.href = publishURL;
      // } else {
      //   const publishURL = `/publish/${name}/${email}/${mobile}/${total}/${promoCode}`;
      //   window.location.href = publishURL;
      // }
    } else {

    }
  };
  
  return (
    <div>
      <Helmet>
        <title>{t.checkoutTitle} | {process.env.REACT_APP_SITE_NAME}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <BackButtonWhite />
      <NavBar />
      <div className="py-24 px-8">
        <div className="md:max-w-xl md:mx-auto bg-white p-4 md:p-8 md:rounded md:shadow-lg">
          <h1 className="text-3xl mb-6 text-center font-semibold">{t.checkoutTitle}</h1>

          {/* Product Summary */}
          <div className="mb-6">
            <h2 className="text-lg font-semibold mb-2">{t.productSummary}</h2>
            <p className="text-gray-700">{t.plan} <span className='uppercase'>{pakej}</span></p>
            <p className="text-gray-700">{t.price} ${price}</p>
          </div>

          {/* Billing Information */}
          <div className="mb-6">
            <h2 className="text-lg font-semibold mb-2">{t.billingInformation}</h2>
            <div className="mb-4">
              <label htmlFor="fullName" className="block text-sm font-medium text-gray-600">
                {t.name}
              </label>
              <input
                type="text"
                id="fullName"
                name="fullName"
                className="mt-1 p-2 w-full border rounded-md"
                placeholder={t.enterYourName}
                required
                value={name}  // Update to use the state variable
                onChange={handleChange}  // Update to use the handleChange function
              />
              {errors.name && <p className="text-secondary-700 text-sm mt-1">{errors.name}</p>}
            </div>
            <div className="mb-4">
              <label htmlFor="mobile" className="block text-sm font-medium text-gray-600">
                {t.phoneNumber}
              </label>
              <div className='flex'>
                <input
                  type="tel"
                  id="mobile"
                  name="mobile"
                  className="mt-1 p-2 w-full border rounded-md"
                  placeholder={t.enterYourPhoneNumber}
                  required
                  value={mobile}  // Update to use the state variable
                  onChange={handleChange}  // Update to use the handleChange function
                />
              </div>
              {errors.mobile && <p className="text-secondary-700 text-sm mt-1">{errors.mobile}</p>}
            </div>
            <div className="mb-4">
              <label htmlFor="email" className="block text-sm font-medium text-gray-600">
                {t.email}
              </label>
              <input
                type="email"
                id="email"
                name="email"
                className="mt-1 p-2 w-full border rounded-md"
                value={email}
                onChange={handleChange}
                disabled
              />
              {errors.email && <p className="text-secondary-700 text-sm mt-1">{errors.email}</p>}
            </div>
          </div>

          {/* Promo Code */}
          <div className="mb-6">
            <h2 className="text-lg font-semibold mb-2">{t.promoCode}</h2>
            <div className="flex">
              <input
                type="text"
                id="promoCode"
                name="promoCode"
                className="p-2 w-full border rounded-md"
                placeholder={t.enterPromoCode}
                value={promoCode}
                onChange={(e) => setPromoCode(e.target.value)}
              />
              {loading ? ( 
                <div className="">
                  <FaSpinner className="text-4xl text-secondary animate-spin" />
                </div>
              ) : (
                <div> 
                  <button
                    className="btn-primary ml-2 py-2 px-4 rounded-md font-semibold"
                    type="button"
                    onClick={applyPromoCode}
                  >
                    {t.apply}
                  </button>
                </div>
              )}
            </div>
            {successMessage && <p className="text-green-600">{successMessage}</p>}
            {errorMessage && <p className="text-red-600">{errorMessage}</p>}
          </div>

          {/* Order Summary */}
          <div className="mb-6">
            <h2 className="text-lg font-semibold mb-2">{t.orderSummary}</h2>
            <div className="flex justify-between mb-2">
              <span>{t.subtotal}</span>
              <span>$ {subtotal}</span>
            </div>
            {discount > 0 && (
              <div className="flex justify-between mb-2">
                <span>{t.discount}</span>
                <span>- $ {discount.toFixed(2)}</span>
              </div>
            )}
            <div className="flex justify-between">
              <span>{t.total}</span>
              <span>$ {(subtotal - discount).toFixed(2)}</span>
            </div>
          </div>

          {/* Place Order Button */}
          <div className="text-center">
            {loadingPay ? (
              <button className='bg-gray-200 disabled py-2 px-4 rounded-md'>
                <p className='flex items-center justify-between'><>{t.processing} </> <FaSpinner className="ml-2 text-2xl text-primary animate-spin" /></p>
              </button>
            ) : (
              <button
                className="btn-primary py-2 px-4 rounded-md font-semibold"
                type="button"
                onClick={handleSubmit}
              >
                {subtotal - discount === 0 ? (
                  <>{t.activate}</>
                ) : (
                  <>{t.buyNow}</>
                )}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Checkout;
